export type DevLuxPlusMembershipState = 'active' | 'awaiting_renewal'

const DAY_MS = 24 * 60 * 60 * 1000
const DEV_OVERRIDE_SUBSCRIPTION_PRICE = 249
const AWAITING_RENEWAL_OVERDUE_DAYS = 2
const AWAITING_RENEWAL_NEXT_RETRY_DAYS = 1
const AWAITING_RENEWAL_FINAL_RETRY_DAYS = 5
const ACTIVE_MEMBERSHIP_DAYS_REMAINING = 365

export function applyDevLuxPlusMembershipState(
  item: App.MemberSubscriptionItem,
  membershipState: DevLuxPlusMembershipState,
  now = Date.now(),
): App.MemberSubscriptionItem {
  const currentSubscriptionPrice = item.currentSubscriptionPrice ?? DEV_OVERRIDE_SUBSCRIPTION_PRICE

  if (membershipState === 'awaiting_renewal') {
    return {
      ...item,
      status: 'AWAITING_RENEWAL',
      renewalStatus: 'ALLOW_RENEWAL',
      isWithinRenewalGracePeriod: true,
      expiryDate: new Date(now - (AWAITING_RENEWAL_OVERDUE_DAYS * DAY_MS)).toISOString(),
      nextChargeAttemptDate: new Date(now + (AWAITING_RENEWAL_NEXT_RETRY_DAYS * DAY_MS)).toISOString(),
      finalChargeAttemptDate: new Date(now + (AWAITING_RENEWAL_FINAL_RETRY_DAYS * DAY_MS)).toISOString(),
      currentSubscriptionPrice,
    }
  }

  return {
    ...item,
    status: 'ACTIVE',
    renewalStatus: item.renewalStatus ?? 'ALLOW_RENEWAL',
    isWithinRenewalGracePeriod: false,
    expiryDate: new Date(now + (ACTIVE_MEMBERSHIP_DAYS_REMAINING * DAY_MS)).toISOString(),
    nextChargeAttemptDate: new Date(now + (ACTIVE_MEMBERSHIP_DAYS_REMAINING * DAY_MS)).toISOString(),
    finalChargeAttemptDate: undefined,
  }
}

export function getDevLuxPlusMembershipState(
  item: App.MemberSubscriptionItem | undefined,
): DevLuxPlusMembershipState {
  if (item?.status === 'AWAITING_RENEWAL') return 'awaiting_renewal'
  return 'active'
}
